import { render, staticRenderFns } from "./ykc-upload.vue?vue&type=template&id=fd28ead2&"
import script from "./ykc-upload.vue?vue&type=script&lang=js&"
export * from "./ykc-upload.vue?vue&type=script&lang=js&"
import style0 from "./ykc-upload.vue?vue&type=style&index=0&id=fd28ead2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports